import { render, staticRenderFns } from "./TingListView.vue?vue&type=template&id=706a7230"
import script from "./TingListView.vue?vue&type=script&lang=js"
export * from "./TingListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports